import theme from 'src/theme/index';

export const cardBase = {
    marginBottom: 3,
    boxShadow: '2px 2px 2px 1px rgb(0 0 0 / 10%)'
};

export const cardHeader = {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    fontSize: '12px',
    fontWeight: 400,
    padding: "12px 16px"
}